import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';
import { SUBSCRIPTION_HEADER_NAME } from '../constants/constants';
import { saveFile } from '../helpers/saveFile';
import { API_ROOT } from '../helpers/apiConfig';

export const actions = {
	projects: () => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/projects',
					method: 'GET',
					types: [
						types.LOAD_PROJECTMGR_DASHBOARD_SUMMARY_REQUEST,
						types.LOAD_PROJECTMGR_DASHBOARD_SUMMARY_SUCCESS,
						types.LOAD_PROJECTMGR_DASHBOARD_SUMMARY_FAILURE,
					],
				},
			});
		};
	},
	loadProjectBaselines: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/project-baselines',
					method: 'POST',
					body: request,
					types: [types.LOAD_PROJECT_BASELINES_REQUEST, types.LOAD_PROJECT_BASELINES_SUCCESS, types.LOAD_PROJECT_BASELINES_FAILURE],
				},
			});
		};
	},
	searchProjectBaselinesV2: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/project-baselines/v2',
					method: 'POST',
					body: request,
					types: [
						types.LOAD_PROJECT_BASELINES_REQUEST_V2,
						types.LOAD_PROJECT_BASELINES_SUCCESS_V2,
						types.LOAD_PROJECT_BASELINES_FAILURE_V2,
					],
				},
			});
		};
	},
	listProjectBaselines: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/list-project-baselines',
					method: 'POST',
					body: request,
					types: [
						types.LIST_PROJECT_BASELINES_REQUEST,
						types.LIST_PROJECT_BASELINES_SUCCESS,
						types.LIST_PROJECT_BASELINES_FAILURE,
					],
				},
			});
		};
	},
	linkProjectBaseline: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/link-project-baseline',
					method: 'POST',
					body: request,
					types: [types.LINK_PROJECT_BASELINE_REQUEST, types.LINK_PROJECT_BASELINE_SUCCESS, types.LINK_PROJECT_BASELINE_FAILURE],
				},
			});
		};
	},
	loadProjectBaselineFilters: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/project-baseline-filters',
					method: 'POST',
					body: request,
					types: [
						types.LOAD_PROJECT_BASELINE_FILTERS_REQUEST,
						types.LOAD_PROJECT_BASELINE_FILTERS_SUCCESS,
						types.LOAD_PROJECT_BASELINE_FILTERS_FAILURE,
					],
				},
			});
		};
	},
	loadProjectFilesFilters: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/project-files-filters',
					method: 'POST',
					body: request,
					types: [
						types.LOAD_PROJECT_FILES_FILTERS_REQUEST,
						types.LOAD_PROJECT_FILES_FILTERS_SUCCESS,
						types.LOAD_PROJECT_FILES_FILTERS_FAILURE,
					],
				},
			});
		};
	},
	searchProjectFiles: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/search-project-files',
					method: 'POST',
					body: request,
					types: [types.SEARCH_PROJECT_FILES_REQUEST, types.SEARCH_PROJECT_FILES_SUCCESS, types.SEARCH_PROJECT_FILES_FAILURE],
				},
			});
		};
	},
	projectFilesBulkApprove: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/project-files-bulk-approve',
					method: 'POST',
					body: request,
					types: [
						types.UPDATE_PROJECT_FILES_APPROVE_REQUEST,
						types.UPDATE_PROJECT_FILES_APPROVE_SUCCESS,
						types.UPDATE_PROJECT_FILES_APPROVE_FAILURE,
					],
				},
			});
		};
	},
	projectFilesBulkDeny: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/project-files-bulk-deny',
					method: 'POST',
					body: request,
					types: [
						types.UPDATE_PROJECT_FILES_DENY_REQUEST,
						types.UPDATE_PROJECT_FILES_DENY_SUCCESS,
						types.UPDATE_PROJECT_FILES_DENY_FAILURE,
					],
				},
			});
		};
	},
	projectFilesBulkReassignFilters: (searchTerm) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/project-files-bulk-reassign-filters',
					method: 'POST',
					body: { searchTerm: searchTerm },
					types: [
						types.SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_REQUEST,
						types.SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_SUCCESS,
						types.SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_FAILURE,
					],
				},
			});
		};
	},
	projectFilesBulkReassign: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/project-files-bulk-reassign',
					method: 'POST',
					body: request,
					types: [
						types.UPDATE_PROJECT_FILES_REASSIGN_REQUEST,
						types.UPDATE_PROJECT_FILES_REASSIGN_SUCCESS,
						types.UPDATE_PROJECT_FILES_REASSIGN_FAILURE,
					],
				},
			});
		};
	},
	projectFilesBulkDownload: (request) => {
		return (dispatch, getState) => {
			const token = getState().user.accessToken;
			const endpoint = 'projectmgr-dashboard/project-files-bulk-download';
			const headers = {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			};
			const method = 'POST';
			const body = JSON.stringify(request);

			const subscriptionId = getState().user.currentSubscriptionId;
			if (subscriptionId) {
				headers[SUBSCRIPTION_HEADER_NAME] = subscriptionId;
			}

			return (
				// eslint-disable-next-line no-undef
				fetch(`${API_ROOT}${endpoint}`, {
					method,
					body,
					headers,
					credentials: 'same-origin',
				}).then(async (response) => {
					await saveFile(response);
				})
			);        
        }
    },
	loadAllProjectTasksGraph: (projectKey) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/all-tasks-by-project-graph',
					method: 'POST',
					body: { projectKey: projectKey },
					types: [
						types.LOAD_PROJECT_ALL_TASKS_GRAPH_REQUEST,
						types.LOAD_PROJECT_ALL_TASKS_GRAPH_SUCCESS,
						types.LOAD_PROJECT_ALL_TASKS_GRAPH_FAILURE,
					],
				},
			});
		};
	},
	loadProjectMilestoneTasksGraph: (projectKey) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/milestone-tasks-by-project-graph',
					method: 'POST',
					body: { projectKey: projectKey },
					types: [
						types.LOAD_PROJECT_MILESTONE_TASKS_GRAPH_REQUEST,
						types.LOAD_PROJECT_MILESTONE_TASKS_GRAPH_SUCCESS,
						types.LOAD_PROJECT_MILESTONE_TASKS_GRAPH_FAILURE,
					],
				},
			});
		};
	},
	loadProjectCoachTasksGraph: (projectKey, signal) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/coach-tasks-by-project-graph',
					method: 'POST',
					body: { projectKey: projectKey },
					signal: signal, // Pass the signal to allow cancellation
					types: [
						types.LOAD_PROJECT_COACH_TASKS_GRAPH_REQUEST,
						types.LOAD_PROJECT_COACH_TASKS_GRAPH_SUCCESS,
						types.LOAD_PROJECT_COACH_TASKS_GRAPH_FAILURE,
					],
				},
			});
		};
	},
	loadProjectCertifiedTasksGraph: (projectKey) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'projectmgr-dashboard/certified-tasks-by-project-graph',
					method: 'POST',
					body: { projectKey: projectKey },
					types: [
						types.LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_REQUEST,
						types.LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_SUCCESS,
						types.LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_FAILURE,
					],
				},
			});
		};
	},
    saveLocationsColumns: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectmgr-dashboard/locations-columns',
                    method: 'PUT',
                    body: request,
                    types: [
                        types.SAVE_LOCATIONS_COLUMNS_REQUEST,
                        types.SAVE_LOCATIONS_COLUMNS_SUCCESS,
                        types.SAVE_LOCATIONS_COLUMNS_FAILURE
                    ]
                }
            });
        }
    },
    saveTasksColumns: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectmgr-dashboard/tasks-columns',
                    method: 'PUT',
                    body: request,
                    types: [
                        types.SAVE_TASKS_COLUMNS_REQUEST,
                        types.SAVE_TASKS_COLUMNS_SUCCESS,
                        types.SAVE_TASKS_COLUMNS_FAILURE
                    ]
                }
            });
        }
    },
    unlinkBaseline: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectmgr-dashboard/unlink-baseline',
                    method: 'PUT',
                    body: request,
                    types: [
                        types.UNLINK_BASELINE_REQUEST,
                        types.UNLINK_BASELINE_SUCCESS,
                        types.UNLINK_BASELINE_FAILURE
                    ]
                }
            });
        }
    },
    tasksAndMilestonesCompletionsGraph: (projectKey, signal) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: `projectmgr-dashboard/task-and-milestone-completion/${projectKey}`,
                    method: 'GET',
					signal: signal, // Pass the signal to allow cancellation
                    types: [
                        types.LOAD_PROJECT_TASKS_AND_MILESTONES_COMPLETIONS_GRAPH_REQUEST,
                        types.LOAD_PROJECT_TASKS_AND_MILESTONES_COMPLETIONS_GRAPH_SUCCESS,
                        types.LOAD_PROJECT_TASKS_AND_MILESTONES_COMPLETIONS_GRAPH_FAILURE
                    ]
                }
            });
        }
    }
};
